var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcArrowOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01535 11.3037L8.01525 11.3036L7.98465 11.3333L3.24538 6.74683C2.91821 6.43021 2.91821 5.91686 3.24538 5.60023C3.57256 5.2836 4.10302 5.2836 4.4302 5.60023L7.98475 9.04015L11.5698 5.57072C11.897 5.2541 12.4274 5.2541 12.7546 5.57072C13.0818 5.88735 13.0818 6.4007 12.7546 6.71733L8.01535 11.3037Z",
    fill: "#333840"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowOpen);
export default __webpack_public_path__ + "static/media/ic_arrow_open.10c3bb64.svg";
export { ForwardRef as ReactComponent };